import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { delay, map, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ValidatorsService {
  constructor(
    private http: HttpClient,
    @Inject('BASE_API_URL') private baseUrl: string
  ) {}

  validateSingleClientId(singleClientId: string) {
    return this.http.get<boolean>(`${this.baseUrl}/client/singleId`, {
      params: { singleId: singleClientId },
    });
  }

  validateLocktonId(locktonId: string) {
    return this.http.get<boolean>(`${this.baseUrl}/client/locktonId`, {
      params: { locktonId },
    });
  }

  validateUmr(umr: string) {
    return this.http.get<boolean>(`${this.baseUrl}/policy/umr`, {
      params: { umr },
    });
  }

  checkEmailExists(email: string) {
    return this.http
      .get<string | void>(`${this.baseUrl}/users/email-check`, {
        params: { email },
      })
      .pipe(map((res) => !!res));
  }
}
